import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/auth/Login'
import MapManagementPlatform from '../components/home/MapManagementPlatform.vue'
import DD_Home from '../components/home/Data_Tools/DD_Home.vue'
import Generic from './../components/home/Generic/Generic.vue'
import axios from 'axios'
import ForgotPassword from '.././components/auth/ForgotPassword.vue'
import Spatial_Intelligence from '.././components/home/Spatial_Intelligence/Spatial_Intelligence.vue'
import TRT_Home from '../components/home/Data_Tools/TRT_Home.vue'
import DT_LandingPage from '../components/home/Data_Tools/DT_LandingPage.vue'
Vue.use(Router)

const router = new Router({
  // mode: "history",
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/mmp',
      name: 'MMP',
      component: MapManagementPlatform,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/data_tools',
      name: 'DataTools',
      component: DT_LandingPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/data_delivery_tool',
      name: 'DDT',
      component: DD_Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/trail_review_tool',
      name: 'TRT',
      component: TRT_Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sales',
      name: 'Sales',
      component: Generic,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/Spatial_Intelligence',
      name: 'Spatial_Intelligence',
      component: Spatial_Intelligence,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/forgotPassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    }
  ]
})

router.beforeEach((to, from, next) => {
  //check to see if route require auth
  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    // check auth state of user
    let token = sessionStorage.getItem('token')

    if (token) {
      // proceed to route
      validateUser(next)
      next()
    } else {
      // no user signed in redirect to login
      next({name: 'Login'})
    }
  } else {
    if (to.path == '/login') {
      sessionStorage.removeItem('token')
    }
    next()
  }
})

function validateUser(next) {
  if (sessionStorage.token) {
    axios
      .get(process.env.API_LOCATION + '/api/auth/', {
        method: 'GET',
        headers: {
          'x-auth-token': sessionStorage.token
        }
      })
      .then(response => {
        const content = response.data
        const status = response.status
        if (content.errors) {
          console.log(content.errors)
          next({name: 'Login'})
        } else {
          if (status != 200) {
            sessionStorage.removeItem('token')
            return
          }
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  } else {
    console.log('No User Token')
  }
}

export default router
